import React, { useEffect, useRef, useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

interface DeviceOrientationState {
  alpha: number | null;
  beta: number | null;
  gamma: number | null;
}

interface Props {
  onSuccess: () => void;
  onError: () => void;
  message?: string | null;
  type: "front" | "side";
  orientation: DeviceOrientationState;
  isPermissionGranted: boolean;
  isSupported: boolean;
}

const defaultMessage = "Place your mobile on the table at 90 degrees";

const StandMobileDegree: React.FC<Props> = ({ type, onSuccess, onError, orientation, isSupported, isPermissionGranted, message = defaultMessage }) => {
  const [hasError, setHasError] = useState(false);
  const degreeWrapperRef = useRef<HTMLDivElement | null>(null);
  const switcherRef = useRef<HTMLDivElement | null>(null);
  const [showMessage, setShowMessage] = useState(true);
  const minDegree = 80;
  const maxDegree = 100;
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (isPermissionGranted && isSupported) {
      handleOrientation(orientation);
    }
  }, [orientation, isPermissionGranted, isSupported]);

  const handleOrientation = (event: DeviceOrientationState) => {
    const beta = event.beta;
    if (beta) {
      setHasError(false);
      if (switcherRef.current) {
        if (beta > maxDegree || beta < minDegree) {
          switcherRef.current.style.top = beta / 2 + "%";
          switcherRef.current.style.backgroundColor = "#d51e3e";
          setShowMessage(true);
          onError();
          setStatus("error");
        } else {
          setShowMessage(false);
          switcherRef.current.style.backgroundColor = "#4ab764";
          switcherRef.current.style.top = beta / 2 + "%";
          onSuccess();
          setStatus("success");
        }
      }
    } else {
      setHasError(true);
      setStatus("error");
    }
  };

  if (hasError) {
    return <></>;
  }

  return (
    <div ref={degreeWrapperRef} className="absolute w-full z-[300] h-screen overflow-hidden">
      {/* {showMessage && (
        <div className="fixed z-50 flex items-center justify-center w-full px-5 text-xl transform -translate-y-1/2 top-1/2">
          <p className="px-5 py-2 font-bold text-center text-white bg-black rounded-xl drop-shadow-2xl bg-opacity-60">{message}</p>
        </div>
      )} */}

      <div className="flex flex-col items-center justify-center gap-2 p-2 m-1 bg-white rounded-full bg-opacity-60 h-[200px] absolute top-1/2 -translate-y-1/2 left-[3px]">
        <div ref={switcherRef} className="absolute z-50 flex items-center justify-center w-6 h-6 -translate-x-1/2 bg-red-500 rounded-full left-1/2">
          {showMessage ? <CloseOutlined className="text-xs text-white" /> : <CheckOutlined className="text-xs text-white" />}
        </div>
        <div className="w-4 h-4 bg-red-500 rounded-full opacity-50" />
        <div className="w-4 h-4 bg-red-500 rounded-full opacity-50" />
        <div className="w-4 h-4 bg-green-500 rounded-full opacity-50" />
        <div className="w-4 h-4 bg-red-500 rounded-full opacity-50" />
        <div className="w-4 h-4 bg-red-500 rounded-full opacity-50" />
      </div>
    </div>
  );
};

export default StandMobileDegree;
